/* eslint-disable node/no-deprecated-api */
import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/FormInput'
import {reduxForm, Field, reset} from 'redux-form'
import {parse as urlParse} from 'url'
import isURL from 'validator/lib/isURL'

function paramsToObject(entries) {
  const result = {}
  for (const [key, value] of entries) {
    result[key] = value
  }
  return result
}

export class AddMappingForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    mappingMode: PropTypes.string.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mappingMode !== nextProps.mappingMode) {
      nextProps.reset()
    }
  }

  render() {
    const {handleSubmit, invalid} = this.props
    return (
      <form
        className='settings-categories-view_add-form'
        onSubmit={handleSubmit}
      >
        <label htmlFor='url'>Add new mapping(URL): </label>
        <Field name='url' component={FormInput} />
        <button type='submit' disabled={invalid}>
          Add
        </button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addMappingForm',
  validate: ({url: value}, props) => {
    const {mappingMode} = props
    const errors = {}
    if (!value) {
      errors.url = 'URL is required'
    } else {
      if (mappingMode === 'exact_url' && !isURL(value)) {
        errors.url = 'URL is not correct'
      }
    }

    return errors
  },
  onSubmit: ({url}, dispatch, props) => {
    const {mappingMode} = props
    const {protocol, host, pathname, search} = urlParse(url)
    const origin = protocol && host ? `${protocol}//${host}` : null
    const params = search ? paramsToObject(new URLSearchParams(search)) : {}

    if (mappingMode === 'url_fragment') {
      props.onAdd({origin, pathname, params})
    } else if (mappingMode === 'exact_url') {
      props.onAdd({url})
    } else if (mappingMode === 'text') {
      props.onAdd({text: url})
    }
    dispatch(reset('addMappingForm'))
  }
})(AddMappingForm)



// WEBPACK FOOTER //
// ./client/views/SettingsCustomMappingView/AddMappingForm.js